import { createApi } from "@reduxjs/toolkit/query/react";

import { tomService } from "./restService";

export const marketDataApi = createApi({
  reducerPath: "marketDataApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/company`,
  }),
  tagTypes: ["MarketData", "MarketDataVersions"],
  endpoints: builder => ({
    updateMarketDataVersion: builder.mutation({
      query: ({ id, company_id }) => ({
        url: `/${company_id}/market-data-version/${id}/set-active/`,
        method: "PATCH",
      }),
      invalidatesTags: ["MarketData", "MarketDataVersions"],
    }),
    fetchMarketDataVersions: builder.query({
      query: ({ company_id, page = 1, page_size }) => ({
        url: `/${company_id}/market-data-versions/?page=${page}&page_size=${page_size}`,
        method: "GET",
      }),
      providesTags: ["MarketDataVersions"],
    }),
    uploadMarketData: builder.mutation({
      query: ({ company_id, active, body }) => ({
        url: `/${company_id}/market-data/upload/?active=${active}`,
        method: "POST",
        body,
        formData: true,
      }),
      invalidatesTags: ["MarketData", "MarketDataVersions"],
    }),
    downloadMarketData: builder.query({
      query: ({ company_id, version_id }) => ({
        url: `/${company_id}/market-data/download/${version_id ? `?version_id=${version_id}` : ""
          }`,
        method: "GET",
      }),
    }),

    deleteMarketDataVersion: builder.mutation({
      query: ({ company_id, version_id }) => ({
        url: `/${company_id}/market-data-version/${version_id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["MarketData", "MarketDataVersions"],
    }),
  }),
});
export const {
  useDownloadMarketDataQuery,
  useFetchMarketDataVersionsQuery,
  useUpdateMarketDataVersionMutation,
  useUploadMarketDataMutation,
  useDeleteMarketDataVersionMutation,
} = marketDataApi;
